

























import { Component, Vue } from 'vue-property-decorator';

@Component({
  props: {
    hasActionTitle: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    hideOutline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
})
export default class RdmCollapsableControlCard extends Vue {
  toggleOpenAction() {
    this.isOpen = !this.isOpen;
  }

  toggleOpen() {
    if (this.$props.hasActionTitle) {
      return;
    }
    this.toggleOpenAction();
  }

  get isOpen() {
    return this.$props.open;
  }

  set isOpen(open) {
    this.$emit('toggle', open);
  }

  get isDisabled() {
    return this.$props.disabled;
  }

  set isDisabled(disabled) {
    this.$emit('toggle-disabled', disabled);
  }
}
